// @flow strict

import * as React from 'react';
import HeaderHero from '../../components/HeaderHero';
import HeaderCta from '../../components/HeaderCta';
import type { BlockRichText } from '../../internal/types';

type TopPropTypes = {|
  highlight: string,
  title: string,
  subtitle: string,
  intro: BlockRichText,
  image: string,
  videoUrl?: string,
  isStaticHeader?: boolean,
|};

export const CaseStudyLandingTop = (props: TopPropTypes) => {
  return (
    <>
      {props.isStaticHeader ? (
        <HeaderCta title={props.title} subtitle={props.subtitle} image={props.image} />
      ) : (
        <HeaderHero
          highlight={props.highlight}
          title={props.title}
          subtitle={props.subtitle}
          image={props.image}
          videoUrl={props.videoUrl}
        >
          {props.intro}
        </HeaderHero>
      )}
    </>
  );
};

export const CaseStudyLandingBottom = () => {
  return null;
};
